import React, { useEffect, useState } from 'react'
import './Applications.css'
import { MdEdit } from 'react-icons/md'
import { TiDeleteOutline } from 'react-icons/ti'
import axios from 'axios'
import { Baseurl } from '../../../../Config/Baseurl'
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DataTable from 'react-data-table-component'
import { CSVLink } from 'react-csv'
import moment from 'moment'
import Tippy from '@tippyjs/react'
import 'tippy.js/dist/tippy.css'

export const Applications = (props) => {
  toast.configure()
  const navigate = useNavigate()
  const logout = () => {
    localStorage.clear()
    navigate('/ADMS')
  }

  const currentDate = new Date().toISOString().split('T')[0]
  const token = localStorage.getItem('token')
  const [search, setSearch] = useState('')

  const [id, setId] = useState()
  const [data, setData] = useState([])
  const [filteredData, setFilteredData] = useState([])

  // fetch data from props and set instate
  useEffect(() => {
    if (props.data) {
      setData(props.data)
      setFilteredData(props.data)
    }
  }, [props.data])

  //onChange
  //filter data on onchange of search box
  const onChange = () => {
    const result = data.filter((item) => {
      return (
        item.designation.toLowerCase().match(search.toLowerCase()) ||
        item.candidate_name.toLowerCase().match(search.toLowerCase()) ||
        item.email.toLowerCase().match(search.toLowerCase()) ||
        item.status_hr.toLowerCase().match(search.toLowerCase()) ||
        item.interview_round.toLowerCase().match(search.toLowerCase()) ||
        item.final_status.toLowerCase().match(search.toLowerCase()) ||
        item.final_status.match(search)
      )
    })

    setFilteredData(result)
  }

  // delete the data of candidate
  const deleteData = async (email) => {
    await axios
      .post(
        Baseurl.nodeLocal + 'candidate/deleteFormData',
        {
          id: id,
        },
        {
          headers: { Authorization: `Bearer ${token}` },
        },
      )
      .then((response) => {
        toast.success(response.data.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        setTimeout(() => {
          window.location.reload(false)
        }, 2000)
      })
      .catch((error) => {
        toast.error(error.message, {
          position: toast.POSITION.TOP_RIGHT,
          autoClose: 2000,
        })
        if (error.response.status === 401) {
          logout()
        }
      })
  }

  // columns to display data of candidate in table
  const columns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      // selector: (row, index) =>
      //   page === 1 ? index + 1 : (page - 1) * size + (index + 1),
      sortable: true,

      width: '80px',
    },
    {
      name: 'Name',

      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },

      width: '150px',
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {' '}
              {row.designation}
            </p>
          </Tippy>
        )
      },

      width: '150px',
    },
    {
      name: 'Applied date',
      cell: (row) => {
        return (
          <Tippy content={row.applied_date} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {moment(row.applied_date).format('DD-MM-YYYY')}
            </p>
          </Tippy>
        )
      },

      width: '110px',
    },
    {
      name: 'HR Status',
      selector: (row) => row.status_hr,
      sortable: true,
      width: '110px',
    },
    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '130px',
    },
    {
      name: 'Final Status',
      cell: (row) => {
        return (
          <Tippy content={row.final_status} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.final_status}
            </p>
          </Tippy>
        )
      },

      width: '110px',
    },
    {
      name: 'Interviewer',
      cell: (row) => {
        return (
          <Tippy content={row.interviewer_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.interviewer_name}
            </p>
          </Tippy>
        )
      },

      width: '130px',
    },

    {
      name: 'Action',
      cell: (row) => {
        return (
          <>
            <Link to={'/applicantProfile/' + row.uuid} className="link">
              <MdEdit className="editbtn" />
            </Link>

            <TiDeleteOutline
              className="deletebtn"
              onClick={() => {
                setId(row.uuid)
              }}
              data-bs-target="#deleteModal"
              data-bs-toggle="modal"
            />
          </>
        )
      },
    },
    {
      name: 'Assigned Owner',
      cell: (row) => {
        return (
          <Tippy content={row.owner_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
              className="text-truncate"
            >
              {row.owner_name}
            </p>
          </Tippy>
        )
      },

      width: '130px',
    },
  ]

  // columns to display up coming interviews of loggedin user in data table
  const interviewColumns = [
    {
      name: 'Sr.no',
      selector: (row) => row.id,
      sortable: true,
      width: '80px',
    },
    {
      name: 'Name',
      cell: (row) => {
        return (
          <Tippy content={row.candidate_name} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {' '}
              {row.candidate_name}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },

    {
      name: 'Designation',
      cell: (row) => {
        return (
          <Tippy content={row.designation} theme="bootstrap">
            <p
              style={{
                marginTop: '1rem',
              }}
            >
              {' '}
              {row.designation}
            </p>
          </Tippy>
        )
      },
      sortable: true,
    },

    {
      name: 'Interview Round',
      selector: (row) => row.interview_round,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Interview Date',
      selector: (row) => moment(row.interview_date).format('DD-MM-YYYY'),
      sortable: true,
      width: '150px',
    },
    {
      name: 'Interview Time',
      selector: (row) => row.interview_time,
      sortable: true,
      width: '150px',
    },
    {
      name: 'Actions',
      cell: (row) => {
        return (
          <Link to={'/viewDetails/' + row.uuid} className="link">
            <button className="btn btn-outline-primary btn-sm">
              View Details
            </button>
          </Link>
        )
      },
      sortable: true,
      width: '150px',
    },
  ]

  // resetting format of contact and applied date for csv file
  const formatdata = filteredData?.map((row) => ({
    ...row,
    applied_date: moment(row.applied_date).format('YYYY-MM-DD'),
    contact: `=""${row.contact}""`,
  }))

  // to store current page index of table
  const onPageChange = (pageIndex) => {
    global.pageNumber = pageIndex
  }

  return (
    <div className="container applications  p-4">
      <h5 className="text-primary">
        {props.status ? 'Up Coming interviews' : props.header}
      </h5>
      <DataTable
        columns={props.status ? interviewColumns : columns}
        data={props.status ? props.profiles : filteredData}
        pagination
        highlightOnHover
        onChangePage={onPageChange}
        paginationDefaultPage={global.pageNumber ? global.pageNumber : 1}
        subHeader
        responsive
        subHeaderComponent={
          <>
            {/* search box to filter data */}
            <input
              type="text"
              placeholder="Search Here..."
              className="w-25 form-control"
              value={search}
              // onChange={(e) => setSearch(e.target.value)}
              onChange={(e) => {
                setSearch(e.target.value)
                onChange()
              }}
            />

            {/* export data in csv */}
            <CSVLink
              data={formatdata}
              filename={'Applications - ' + currentDate}
            >
              <button className="btn btn-primary mx-2">Export</button>
            </CSVLink>
          </>
        }
      />

      {/* modal for confirmation to delete data */}
      <div
        className="modal"
        tabIndex="-1"
        id="deleteModal"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Alert</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>Are you sure you want to delete the data ?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  deleteData()
                }}
                data-bs-dismiss="modal"
              >
                Confirm
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
